import { getEndpoint } from "@api-routes/endpoint";
import { USAGE_SERVICE_TYPE } from "@constants";

const USAGE_CONSUMPTION_MS_NAME = "cdr-usage-consumption";
export const getUsageDetailsRoute = (billingPeriod: string, serviceId: number, query: string) =>
    `${getEndpoint(
        USAGE_CONSUMPTION_MS_NAME
    )}usages/services/${serviceId}/paginated${query}&billingPeriod=${billingPeriod}&subscriptionType=${USAGE_SERVICE_TYPE}`;

export const getUsageSummaryRoute = (serviceId: number, billingPeriod: string) =>
    `${getEndpoint(
        USAGE_CONSUMPTION_MS_NAME
    )}usages/services/${serviceId}/summary?billingPeriod=${billingPeriod}&subscriptionType=${USAGE_SERVICE_TYPE}`;

export const getUsageTypeListRoute = () => `${getEndpoint(USAGE_CONSUMPTION_MS_NAME)}ref-usage-types`;
